var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('other-earnings-charges-table',{attrs:{"chargeList":_vm.charges}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }